import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Environment } from './environment.model';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1 ||
  window.navigator.userAgent.indexOf('Edge') > -1;

/**
 * This file will be replaced during prod build through the prebuild.js script.
 * That way, prod setting apply for deployed versions.
 */
export const environment: Environment = {
  production: false,
  azureEndpoint: 'https://test.api.schenck.one',
  apiBaseUrl: 'https://test.api.schenck.one/um/v2', // against deployed/cloud backend
  usBaseUrl: 'https://test.api.schenck.one/user', // against deployed/cloud backend
  umBaseUrl: 'https://test.api.schenck.one/um/v2/rights/UM', // against deployed/cloud backend
  amBaseUrl: 'https://test.api.schenck.one/am/v1', // against deployed/cloud backend
  googleApiKey: 'AIzaSyCaCOvpgCooOPqfq4yIgpasYKr2-k9xIWQ',
  // DON'T change the following line! it will be replaced by a build-step with correct values
  versionInfo: {
    tag: 'test',
    hash: '9720802e5b78b03abdba0b8b1f1ed1ca289b3d31',
    buildtimestamp: '2026-10-07T13:31:43.3321931Z',
    buildVersion: '2.1.0+1088',
  },
  msalConfig: {
    msal: {
      auth: {
        clientId: '530e9288-d317-4a29-a6e2-4f52634662bf',
        knownAuthorities: ['durrgroupb2c.b2clogin.com'],
        authority: 'https://durrgroupb2c.b2clogin.com/durrgroupb2c.onmicrosoft.com/B2C_1A_SIGNIN',
        redirectUri: 'https://test.usermanager.schenck.one',
        postLogoutRedirectUri: 'https://test.usermanager.schenck.one/postlogout',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: true, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    },
    guard: {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [
          'https://durrgroupb2c.onmicrosoft.com/58a9657b-ab0c-45f2-8ae8-da25f14074a7/API.All',
        ],
      },
      loginFailedRoute: '/login-failed',
    },
  },
};
